<template>
    <div class="trashed-members-item cols-3 gap-1">
        <user-thumb :user="member.user"
                    align="center"
                    with-avatar
                    with-organization
                    compact />
        <div class="f-y-center">
            {{ date }}
        </div>
        <div class="f-y-center">
            {{ member.deleted_by_translated }}
        </div>
    </div>
</template>

<script>
import { labelAt } from '@/utils/date'

import UserThumb from '@/components/users/UserThumb.vue'

export default {
  name: 'TrashedMembersItem',

  components: {
    UserThumb
  },

  props: {
    member: { type: Object, default: () => ({}) }
  },

  computed: {
    date() {
      return labelAt(this.member.deleted_at, { iso: true, zoned: false, withAlias: false })
    }
  }
}
</script>

<style lang="scss">
.trashed-members-item:not(:last-child) {
  border-bottom: 1px solid #F5F5F5;
  padding-bottom: 0.5rem;
}
</style>